<template>
	<div>
		<div class="wallpaper">
			<div class="PC_headImg">
				<img src="../../../assets/headImg/head.jpg" alt="">
			</div>
			<div>
				<pcBack></pcBack>
				<div class="retrun_pc" @click="lastStep" v-if="process == 2">返回</div>
			</div>
			<div v-if="process == 1" class="cate">
				<ul v-for="(item,index) in JsonData" :Key="index">
					<li @click="nextStep(item)">
						<img :src="item.img" alt="" style="width: 100%;height: 12.5rem;">
						<span>{{item.cateName}}</span>
						<label>数量：{{item.amount}}</label>
					</li>
				</ul>
			</div>
			<div v-if="process == 2" v-for="(item,index) in cardJson" :Key="index" class="crad" style="float: left;">
				<el-card class="box-card" shadow="hover" style="width: 96%; margin: 0.625rem auto;">
					<div slot="header" class="clearfix">
						<span>编号：{{item.number}}</span>
						<span style="width: 60%;text-align: center;display: inline-block;">{{item.cardName}}</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="showImg">查看</el-button>
						<el-drawer :visible.sync="dialogVisible" size="100%" custom-class="el-drawer rtl">
							<div style="width: 90%;margin: 0 auto;">
								<img :src="item.cradImg" alt="" width="100%">
							</div>
						</el-drawer>
					</div>
					<div style="display: flex;">
						<div class="text item" style="width: 100%;">
							<span>标题：{{item.title}}</span>
							<span>作者：{{item.author}}</span>
							<label style="color: gray;">{{item.hospital}}</label>
						</div>
					</div>
				</el-card>
			</div>

		</div>

		<div v-if="process == 1">
			<logocom></logocom>
		</div>

		<div  v-if="process == 2">
			<div class="flex" style="margin-bottom: 70px;">
				<div class="logo">
					<img src="../../../assets/ganzhiyu.png" style="width: 100%;padding-top: 3px;" />
				</div>
				<div style="color: #666;font-size: 13px;" >提供技术支持</div>
			</div>
			<div class="btn-box">
				<div class="retrun_phone" @click="lastStep">返回</div>
				<div class="retrun_phone" @click="retrun_home">返回首页</div>
			</div>
		</div>


		<div style="display: none;">
			<titlecom :title="stay"></titlecom>
			<div v-if="!isPaperList">

				<el-steps :space="200" :active=step finish-status="success" align-center>
					<el-step title="阅读投稿须知"></el-step>
					<el-step title="填写作者信息"></el-step>
					<el-step title="填写稿件内容"></el-step>
					<el-step title="稿件预览"></el-step>
					<el-step title="完成投稿"></el-step>

				</el-steps>

				<br>
				<div v-if="process == 1">

					<el-button type="primary" @click="paperList(1)" style="float: right;">查看投稿记录</el-button>
					<div class="zw_require">
						<p>征文要求：</p>
						<p>1.内容：细菌、真菌感染诊断、治疗和防控的基础与临床研究；</p>
						<p>2.论文要求尚未在公开发行的期刊上发表。提供中文或英文摘要（500字以内），包含题目、作者及单位、目的、方法、结果、结论、关键词，并附电子邮件地址。</p>
						<p>3.会议设立优秀论文奖，参加青年优秀论文评选者（要求年龄40岁以内），请全文投稿，并注明是否参与优秀论文评选。</p>
						<p style="margin-bottom: 40px;">4.通过大会网站投稿，截稿日期2021年3月25日。</p>
						<div style="margin-bottom: 20px">
							<el-radio-group v-model="isEnglish" class="but-left radio-group">
								<el-radio :label="2">中文投稿</el-radio>
								<el-radio :label="1">英文投稿</el-radio>
							</el-radio-group>
						</div>
						<span>已阅读提交要求</span>
						<el-button type="primary" @click="nextStep" class="but-left">开始提交</el-button>
					</div>
				</div>

				<div v-if="process == 2">
					<el-form :model="authorForm" :rules="author" ref="authorForm" label-width="100px" class="demo-ruleForm">
						<el-form-item>

							<el-checkbox label="我是第一作者" @change="firstAuthor"></el-checkbox>

						</el-form-item>
						<el-form-item label="中文姓名" prop="name">
							<el-input v-model="authorForm.name"></el-input>
						</el-form-item>
						<el-form-item label="姓的拼音">
							<el-input v-model="authorForm.surnamePinyin"></el-input>
						</el-form-item>
						<el-form-item label="名的拼音">
							<el-input v-model="authorForm.namePinyin"></el-input>
						</el-form-item>
						<el-form-item label="所在省份" prop="province">
							<el-select v-model="authorForm.province" placeholder="请选择">
								<el-option :label=prov.label :value=prov.value v-for="prov in provs"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="工作单位" prop="company">
							<el-input v-model="authorForm.company"></el-input>
						</el-form-item>
						<el-form-item label="科室/部门" prop="department">
							<el-input v-model="authorForm.department"></el-input>
						</el-form-item>
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="authorForm.phone"></el-input>
						</el-form-item>
						<el-form-item label="电子邮箱" prop="email">
							<el-input v-model="authorForm.email"></el-input>
						</el-form-item>

						<el-form-item>
							<el-button v-if="!isupPaper && ID == 0 " @click="lastStep">上一步 | 阅读投稿须知</el-button>
							<el-button type="primary" @click="nextStep('authorForm')">下一步 | 填写其他作者信息</el-button>
						</el-form-item>
					</el-form>
				</div>

				<div v-if="process == 3">
					<p>发言作者</p>
					<el-form :model="speakForm" :rules="speaker" ref="speakForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="姓名" prop="speakerName">
							<el-input v-model="speakForm.speakerName"></el-input>
						</el-form-item>
						<el-form-item label="电子邮箱" prop="speakerEmail">
							<el-input v-model="speakForm.speakerEmail"></el-input>
						</el-form-item>
						<el-form-item label="手机" prop="speakerPhone">
							<el-input v-model="speakForm.speakerPhone"></el-input>
						</el-form-item>
						<el-form-item label="姓的拼音">
							<el-input v-model="speakForm.speakerSurnamePinyin"></el-input>
						</el-form-item>
						<el-form-item label="名的拼音">
							<el-input v-model="speakForm.speakerNamePinyin"></el-input>
						</el-form-item>
						<el-form-item label="所属单位" prop="speakerDepartment">
							<el-input v-model="speakForm.speakerDepartment"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="lastStep">上一步 | 填写作者信息</el-button>
							<el-button type="primary" @click="nextStep('speakForm')">下一步 | 填写其他作者信息</el-button>
						</el-form-item>
					</el-form>
				</div>

				<div v-if="process == 4">
					<span>所有作者</span>
					<el-button icon="el-icon-plus" @click="addAuthor" class="but-left">添加作者</el-button>
					<el-form :model="authorInfoForm[0]" :rules="authorInfo" ref="authorInfoForm" label-width="100px" class="demo-ruleForm">
						<div v-for="(author,item) in authorInfoForm" style="margin-bottom: 20px;">
							<el-form-item :label="'第'+(++item)+'作者'" style="border-bottom: 1px solid silver">
								<i v-if="item !== 1" style="float:right;color: red;" @click="removeAuthor(item)" class="el-icon-delete"></i>
								<div></div>
							</el-form-item>
							<el-form-item label="姓名" :prop="author.authorName">
								<el-input v-model="author.authorName" style="width:200px;"></el-input>

								<!--              <el-radio v-model="author.isContactName" :label="item" @change="getTXAuthor(item)"-->
								<!--                        :name="'radio'+item" class="but-left">通讯作者-->
								<!--              </el-radio>-->
								<el-checkbox v-model="author.isContactName" style="margin-left: 20px;">通讯作者
								</el-checkbox>

								<div v-if="author.isContactName == 1">
									<el-form-item label="电子邮箱" prop="authorEmail" class="addAuthor">
										<el-input v-model="author.authorEmail"></el-input>
									</el-form-item>
									<el-form-item label="手机" prop="authorPhone">
										<el-input v-model="author.authorPhone"></el-input>
									</el-form-item>
								</div>
							</el-form-item>
							<el-form-item :label="'所属单位' + (++index)" prop="authorCompany" v-for="(company,index) in author.authorCompany">
								<el-input v-model="company.name" style="width: 450px;"></el-input>
								<i v-if="index !== 1" style="margin-left: 20px;color: red;" @click="removeCompany(item,index)" class="el-icon-delete"></i>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-plus" @click="addCompany(item)">添加所属单位</el-button>
							</el-form-item>
						</div>
						<div class="addAuthor">
							<span>所有作者</span>
							<el-button icon="el-icon-plus" @click="addAuthor" class="but-left">添加作者</el-button>
						</div>
						<el-form-item>
							<el-button @click="lastStep">上一步 | 填写作者信息</el-button>
							<el-button type="primary" @click="nextStep('authorInfoForm')">下一步 | 填写稿件信息</el-button>
						</el-form-item>
					</el-form>
				</div>

				<div v-if="process == 5 ">
					<el-form :model="manuscriptForm" :rules="manuscript" ref="manuscriptForm" label-width="auto" class="demo-ruleForm">
						<el-form-item :label="isEnglish==2?'拟交流类型':'PresentingType'" prop="presentingType">
							<el-radio-group v-model="manuscriptForm.presentingType">
								<el-radio label="仅刊印"></el-radio>
								<el-radio label="壁报交流"></el-radio>
								<el-radio label="大会发言"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'是否参与优秀论文评选':'Participate Excellent Selection'" prop="isSelection">
							<el-radio-group v-model="manuscriptForm.isSelection">
								<el-radio label=1>{{ isEnglish == 2 ? '是' : 'YES' }}</el-radio>
								<el-radio label=2>{{ isEnglish == 2 ? '否' : 'NO' }}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'主题分类':'Topic'" prop="topic">
							<el-select v-model="manuscriptForm.topic" placeholder="请选择分类">
								<el-option :label="ite" :value="ite" v-for="ite in Topics"></el-option>

							</el-select>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'中文题目':'Title'" prop="title">
							<el-input v-model="manuscriptForm.title"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'目的':'Objective'" prop="objective">
							<el-input type="textarea" v-model="manuscriptForm.objective" rows="10"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'方法':'Methods'" prop="methods">
							<el-input type="textarea" v-model="manuscriptForm.methods" rows="10"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'结果':'Results'" prop="results">
							<el-input type="textarea" v-model="manuscriptForm.results" rows="10"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'结论':'Conclusion'" prop="conclusion">
							<el-input type="textarea" v-model="manuscriptForm.conclusion" rows="10"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'关键字':'Key words'" prop="keywords">
							<el-input v-model="manuscriptForm.keywords"></el-input>
						</el-form-item>
						<el-form-item :label="isEnglish==2?'上传附件':'Upload Attachment'">

							<el-upload action=" " :multiple="false" :on-change="handleUploadChange" :http-request="ossupload"
							 :show-file-list="false" accept=".zip,.rar,.pdf,.doc,.docx">
								<el-button type="primary" icon="el-icon-upload">选择上传</el-button>
							</el-upload>

							<p class="careful_info">参加青年优秀论文评选需全文投稿， 投稿正文、上传文件类型：rar、zip、pdf、doc、docx</p>
							<p>
								<el-link :underline="false" v-for="(item,index) in manuscriptForm.uploadAttachment" :key="index" target="_blank"
								 :href="'https://w.ganzhiyu.com'+item.url">{{ item.name }}
								</el-link>
							</p>
							<el-button type="warning" size="mini" v-if="manuscriptForm.uploadAttachment.length > 0" @click="removeEnclosure"
							 style="margin-top: 20px;">删除附件
							</el-button>

						</el-form-item>
						<el-button @click="lastStep">上一步 | 填写稿件信息</el-button>
						<el-button type="primary" @click="nextStep('manuscriptForm')">下一步 | 稿件预览</el-button>
					</el-form>
				</div>

				<div v-if="process == 6">
					<div>

						<p>拟交流类型：<span>{{ articleInfo.presentingType }}</span></p>
						<p>主题分类:<span>{{ articleInfo.topic }}</span></p>
						<div class="title_info">
							<h3>{{ articleInfo.title }}</h3>
							<h6>
								<span v-for="(item,index) in authorInfoForm">
									{{ item.authorName}}
									<sup style="vertical-align: super;">{{ index + 1 }}
										<span v-if="item.isContactName">*</span>
									</sup>
									<span v-if="(index+1) < ((articleInfo.authorInfo.length))">,</span>
								</span>
							</h6>
							<h6>
								<span v-for="(item,index) in articleInfo.authorInfo">
									<p v-for="(pro,indexPro) in item.authorCompany">
										{{ index + 1 + "." }}
										{{ pro.name }}
									</p>
								</span>
							</h6>
						</div>
						<p>目的：</p>
						<p>{{ articleInfo.objective }}</p>
						<p>方法：</p>
						<p>{{ articleInfo.methods }}</p>
						<p>结果：</p>
						<p>{{ articleInfo.results }}</p>
						<p>结论：</p>
						<p>{{ articleInfo.conclusion }}</p>
						<p>关键字：<span>{{ articleInfo.keywords }}</span></p>
						<span>投稿正文：</span>

						<p v-for="(item,index) in manuscriptForm.uploadAttachment">
							<el-link :underline="false" :key="index" target="_blank" :href="'https://w.ganzhiyu.com'+item.url">
								{{ item.name }}
							</el-link>
						</p>

					</div>
					<div class="stepBut">
						<el-button @click="lastStep">上一步 | 填写作者信息</el-button>
						<el-button type="primary" @click="nextStep">下一步 | 完成稿件</el-button>
					</div>
				</div>
				<div v-if="process == 7" class="tcuss">
					<el-button type="primary" @click="paperList(1)" style="float: right;">查看投稿记录</el-button>
					<h1>稿件提交成功</h1>
					<p>如果您还有其他论文需要继续提交，请 <span @click="again" class="againText">点击这里继续投稿</span>！再次感谢您的支持！</p>
				</div>
			</div>
			<div v-if="isPaperList" style="padding-left: 20px;margin-left: 20px;margin-bottom: 40px;">

				<el-button type="primary" @click="paperStep" class="subMission">点击提交稿件</el-button>
				<el-table :data="paperTable" border style="width: 100%">
					<!--        <el-table-column-->
					<!--            prop="id"-->
					<!--            label="ID"-->
					<!--            width="200">-->
					<!--        </el-table-column>-->
					<el-table-column prop="topic" label="分类">
					</el-table-column>
					<el-table-column prop="title" label="题目">
					</el-table-column>
					<el-table-column prop="status" label="提交状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status===1">未完成</span>
							<span v-else>已完成</span>
						</template>

					</el-table-column>
					<el-table-column prop="uploadAttachment" label="资料上传">
						<template slot-scope="scope">
							<p>
								<el-link :underline="false" v-for="(itA,index) in scope.row.uploadAttachment" :key="index" target="_blank"
								 :href="'https://w.ganzhiyu.com'+itA.url">{{ itA.name }}
								</el-link>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" style="text-align: center">
						<template slot-scope="scope">
							<el-button type="text" size="small" icon="el-icon-edit" v-if="scope.row.status==2?false:true" @click="upPaper(scope.row.id)">修改
							</el-button>
							<el-button type="text" size="small" icon="el-icon-edit" v-if="scope.row.status==2?true:false" @click="revokePaper(scope.row.id)">撤销
							</el-button>
							<el-button type="text" size="small" icon="el-icon-delete-solid" style="color: red" :disabled="scope.row.status==2?true:false"
							 @click="delPaper(scope.row.id)">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background layout="prev, pager, next" :total="pagination.total" :page-size="pagination.count"
				 @current-change="paperList">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import titlecom from "@/components/title/title.vue";
	import pcBack from "../../../components/back/back.vue";
	import OSS from "ali-oss";
	import axios from 'axios';
	import logocom from '../../../components/logo/logo.vue';

	export default {
		data() {
			return {
				dialogVisible: false,
				JsonData: '',
				cardJson: {},
				isEnglish: 2,
				pagination: {
					count: 10,
					total: 0
				},
				item: 0,
				isupPaper: false,
				paperTable: [],
				isPaperList: false,
				uploadFileList: [],
				articleInfo: {},
				ID: 0,
				Topics: ["细菌真菌感染的流行病学", "细菌真菌感染的病原诊断技术", "细菌真菌耐药监测与耐药机制", "抗菌药物的PK/PD研究与临床试验", "细菌真菌感染的治疗", "其他微生物及其感染", "其他"],
				step: 0,
				process: 1,
				stay: '网上论文投稿',
				activeName: 'second',
				authorForm: {
					name: '',
					surnamePinyin: '',
					namePinyin: '',
					province: '',
					company: '',
					department: '',
					phone: '',
					email: ''
				},
				speakForm: {
					speakerName: '',
					speakerEmail: '',
					speakerPhone: '',
					speakerSurnamePinyin: '',
					speakerNamePinyin: '',
					speakerDepartment: ''
				},
				authorInfoForm: [{
					authorName: '',
					isContactName: true,
					authorEmail: '',
					authorPhone: '',
					authorCompany: [{
						name: ''
					}]

				}],
				provs: [{
						label: "北京市",
						value: "北京市"
					},

					{
						label: "天津市",
						value: "天津市"
					},

					{
						label: "河北省",
						value: "河北省"
					},

					{
						label: "山西省",
						value: "山西省"
					},

					{
						label: "内蒙古自治区",
						value: "内蒙古自治区"
					},

					{
						label: "辽宁省",
						value: "辽宁省"
					},

					{
						label: "吉林省",
						value: "吉林省"
					},

					{
						label: "黑龙江省",
						value: "黑龙江省"
					},

					{
						label: "上海市",
						value: "上海市"
					},

					{
						label: "江苏省",
						value: "江苏省"
					},

					{
						label: "浙江省",
						value: "浙江省"
					},

					{
						label: "安徽省",
						value: "安徽省"
					},

					{
						label: "福建省",
						value: "福建省"
					},

					{
						label: "江西省",
						value: "江西省"
					},

					{
						label: "山东省",
						value: "山东省"
					},

					{
						label: "河南省",
						value: "河南省"
					},

					{
						label: "湖北省",
						value: "湖北省"
					},

					{
						label: "湖南省",
						value: "湖南省"
					},

					{
						label: "广东省",
						value: "广东省"
					},

					{
						label: "广西壮族自治区",
						value: "广西壮族自治区"
					},

					{
						label: "海南省",
						value: "海南省"
					},

					{
						label: "重庆市",
						value: "重庆市"
					},

					{
						label: "四川省",
						value: "四川省"
					},

					{
						label: "贵州省",
						value: "贵州省"
					},

					{
						label: "云南省",
						value: "云南省"
					},

					{
						label: "西藏自治区",
						value: "西藏自治区"
					},

					{
						label: "陕西省",
						value: "陕西省"
					},

					{
						label: "甘肃省",
						value: "甘肃省"
					},

					{
						label: "青海省",
						value: "青海省"
					},

					{
						label: "宁夏回族自治区",
						value: "宁夏回族自治区"
					},

					{
						label: "新疆维吾尔自治区",
						value: "新疆维吾尔自治区"
					},

					{
						label: "台湾省",
						value: "台湾省"
					},

					{
						label: "香港特别行政区",
						value: "香港特别行政区"
					},

					{
						label: "澳门特别行政区",
						value: "澳门特别行政区"
					}
				],
				manuscriptForm: {
					presentingType: '',
					isSelection: '',
					topic: '',
					title: '',
					objective: '',
					methods: '',
					results: '',
					conclusion: '',
					keywords: '',
					uploadAttachment: []
				},
				author: {
					name: [{
							required: true,
							message: '请填写中文姓名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 5,
							message: '长度在 2 到 5 个字符',
							trigger: 'blur'
						}
					],
					province: [{
						required: true,
						message: '请选择所属省份',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请填写工作单位',
						trigger: 'blur'
					}],
					department: [{
						required: true,
						message: '请填写科室/部门',
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: '请填写手机号码',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号码长度为 11个数字',
							trigger: 'blur'
						}

					],
					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change']
						}
					]
				},
				speaker: {
					speakerName: [{
							required: true,
							message: '请填写姓名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 5,
							message: '长度在 2 到 5 个字符',
							trigger: 'blur'
						}
					],
					speakerEmail: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change']
						}
					],
					speakerPhone: [{
							required: true,
							message: '请填写手机号码',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号码长度为 11个数字',
							trigger: 'blur'
						}
					],
					speakerSurnamePinyin: [{
						required: true,
						message: '请填写姓的拼音',
						trigger: 'blur'
					}],
					speakerNamePinyin: [{
						required: true,
						message: '请填写名的拼音',
						trigger: 'blur'
					}],
					speakerDepartment: [{
						required: true,
						message: '请填写所属单位',
						trigger: 'blur'
					}]

				},
				authorInfo: {
					authorName: [{
							required: true,
							message: '请填写姓名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 5,
							message: '长度在 2 到 5 个字符',
							trigger: 'blur'
						}
					]
				},
				manuscript: {
					presentingType: [{
						required: true,
						message: '请选择拟交流类型',
						trigger: 'change'
					}],
					isSelection: [{
						required: true,
						message: '请选择是否参与优秀论文评选',
						trigger: 'change'
					}],

					topic: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}],
					title: [{
							required: true,
							message: '请填写中文题目',
							trigger: 'change'
						},
						{
							min: 1,
							max: 64,
							message: '长度在 2 到 64 个字符',
							trigger: 'blur'
						}
					],
					objective: [{
						required: true,
						message: '请填写目的',
						trigger: 'change'
					}],
					methods: [{
						required: true,
						message: '请填写方法',
						trigger: 'change'
					}],
					results: [{
						required: true,
						message: '请填写结果',
						trigger: 'change'
					}],
					conclusion: [{
						required: true,
						message: '请填写结论',
						trigger: 'change'
					}],
					keywords: [{
							required: true,
							message: '请填写关键字',
							trigger: 'change'
						},
						{
							min: 1,
							max: 64,
							message: '长度在 2 到 64 个字符',
							trigger: 'blur'
						}
					]
				}

			}
		},
		methods: {

			retrun_home() {
				this.$router.push({
					path: '/',
				})
			},
			showImg() {
				this.dialogVisible = true;
			},
			//上传
			handleUploadChange(file, fileList) {
				this.uploadFileList = fileList.slice(-3);
			},
			ossupload(file) {
				const ak = 'LTAI4GDL9h' + 'dhWKe4Z293ntH6';
				const aks = 'F8FuqQZAuG1oHE' + 'dSxnkt1hDdpxEhXs';
				const client = new OSS({
					region: 'oss-cn-hangzhou',
					accessKeyId: ak,
					accessKeySecret: aks,
					bucket: 'ganzhiyu'
				});
				const xfname = `/upload-file/paperInfectFile/${this.ID}/${file.file.name}`;
				const that = this;
				client
					.multipartUpload(xfname, file.file, {
						progress: function(p) {
							//p进度条的值
							that.showProgress = true;
							that.progress = Math.floor(p * 100);
						}
					})
					.then(result => {
						//上传成功返回值，可针对项目需求写其他逻辑
						that.$message({
							message: '文件上传成功',
							type: 'success'
						});
						let temp = {
							name: file.file.name,
							url: result.name
						}
						that.manuscriptForm.uploadAttachment.push(temp)
						console.log(that.manuscriptForm.uploadAttachment)
					})
					.catch(err => {
						that.$message.error('上传失败，请重试。');
						console.log('err:', err);
					});
			},

			revokePaper(id) {
				let cnt = {
					id: id,
					status: 1
				}
				this.$api.updatePaper(cnt, res => {
					this.paperList(1)
				})
			},
			//删除论文投稿
			delPaper(id) {

				let cnt = {
					id: id,
					userId: JSON.parse(localStorage.getItem("user")).user.userId
				}
				this.$api.delPaper(cnt, res => {
					if (res.data.rc == "succ" && res.status == 200) {
						alert("删除成功")
						this.paperList(1)
					} else {
						alert("删除失败!")
					}
				})
			},
			//修改论文
			upPaper(id) {
				this.ID = id
				this.isupPaper = true
				this.isPaperList = false
				this.process = 2
				this.step = 1

				let cnt = {
					id: id,
				}
				this.$api.getPaperList(cnt, res => {

					var paper = JSON.parse(res.data.c);
					this.authorInfoForm = paper.authorInfo
					Object.keys(this.authorForm).forEach(key => {
						this.authorForm[key] = paper[key]
					})
					Object.keys(this.speakForm).forEach(key => {
						this.speakForm[key] = paper[key]
					})
					Object.keys(this.manuscriptForm).forEach(key => {
						this.manuscriptForm[key] = paper[key]
					})

				})
			},
			paperStep() {
				this.isPaperList = false
			},
			//投稿记录
			paperList(e) {

				this.isPaperList = true
				let cnt = {
					userId: JSON.parse(localStorage.getItem("user")).user.userId,
					count: this.pagination.count,
					offset: this.pagination.count * (e - 1)
				}
				this.$api.getPaperList(cnt, res => {
					this.paperTable = JSON.parse(res.data.c).list
					this.pagination.total = JSON.parse(res.data.c).sumCount
				})
			},
			//删除附件
			removeEnclosure() {
				this.manuscriptForm.uploadAttachment = []
			},
			//第一作者
			firstAuthor(e) {
				if (e) {
					let cnt = {
						userId: JSON.parse(localStorage.getItem("user")).user.userId,
					}
					this.$api.getUser(cnt, res => {
						let authorInfo = JSON.parse(res.data.c)
						this.authorForm.name = authorInfo.name
						this.authorForm.surnamePinyin = authorInfo.surnamePinyin
						this.authorForm.namePinyin = authorInfo.namePinyin
						this.authorForm.province = authorInfo.district
						this.authorForm.company = authorInfo.company
						this.authorForm.department = authorInfo.department
						this.authorForm.phone = authorInfo.phone
						this.authorForm.email = authorInfo.email

						this.speakForm.speakerName = authorInfo.name
						this.speakForm.speakerEmail = authorInfo.email
						this.speakForm.speakerPhone = authorInfo.phone
						this.speakForm.speakerSurnamePinyin = authorInfo.surnamePinyin
						this.speakForm.speakerNamePinyin = authorInfo.namePinyin
						this.speakForm.speakerDepartment = authorInfo.company


						this.authorInfoForm[0].authorName = authorInfo.name
						this.authorInfoForm[0].isContactName = true
						this.authorInfoForm[0].authorEmail = authorInfo.email
						this.authorInfoForm[0].authorPhone = authorInfo.phone
						this.authorInfoForm[0].authorCompany[0].name = authorInfo.company

					})
				}
			},
			//通讯作者
			getTXAuthor(num) {
				for (let i = 0; i < this.authorInfoForm.length; i++) {
					if (i == (num - 1)) {
						this.authorInfoForm[i].isContactName = true;
					} else {
						this.authorInfoForm[i].isContactName = false;
					}
				}
			},
			again() {
				window.location.reload();
				// this.step = 0
				// this.process = 1
				// this.authorInfoForm = [{
				// 	authorName: '',
				// 	isContactName: 1,
				// 	authorEmail: '',
				// 	authorPhone: '',
				// 	authorCompany: [{
				// 		name: ''
				// 	}],
				// 	}]
			},
			//删除作者
			removeAuthor(number) {
				this.authorInfoForm.splice(--number, 1)
			},

			removeCompany(item, number) {
				this.authorInfoForm[--item].authorCompany.splice(--number, 1)
			},
			//添加所属单位
			addCompany(num) {
				this.authorInfoForm[--num].authorCompany.push({
					name: ''
				})
			},
			//添加作者
			addAuthor() {
				this.authorInfoForm.push({
					authorName: '',
					isContactName: false,
					authorEmail: '',
					authorPhone: '',
					authorCompany: [{
						name: ''
					}]
				})
			},
			//下一步
			nextStep(formName) {

				this.cardJson = formName.crad;

				switch (this.process) {
					case 1:
						this.process++;
						this.step++;
						break;
					case 2:
						let cnt = {
							userId: JSON.parse(localStorage.getItem("user")).user.userId,
							id: this.ID,
							isEnglish: this.isEnglish,
							name: this.authorForm.name,
							surnamePinyin: this.authorForm.surnamePinyin,
							namePinyin: this.authorForm.namePinyin,
							province: this.authorForm.province,
							company: this.authorForm.company,
							department: this.authorForm.department,
							phone: this.authorForm.phone,
							email: this.authorForm.email
						}
						let _this = this
						if (this.isupPaper) {
							this.$refs[formName].validate((valid) => {
								if (valid) {
									this.$api.updatePaper(cnt, res => {
										if (res.status == 200 && res.data.rc == "succ") {
											if (!_this.isupPaper) {
												_this.ID = JSON.parse(res.data.c).id
											}
											this.process++
										}
									})
								}
							})
						} else {
							this.$refs[formName].validate((valid) => {
								if (valid) {
									this.$api.createPaper(cnt, res => {
										if (res.status == 200 && res.data.rc == "succ") {
											_this.ID = JSON.parse(res.data.c).id
											this.process++
										}
									})
								}
							})
						}


						break;
					case 3:
						cnt = {
							id: this.ID,
							speakerName: this.speakForm.speakerName,
							speakerEmail: this.speakForm.speakerEmail,
							speakerPhone: this.speakForm.speakerPhone,
							speakerSurnamePinyin: this.speakForm.speakerSurnamePinyin,
							speakerNamePinyin: this.speakForm.speakerNamePinyin,
							speakerDepartment: this.speakForm.speakerDepartment
						}
						this.$refs[formName].validate((valid) => {

							if (valid) {
								this.$api.updatePaper(cnt, res => {
									if (res.status == 200 && res.data.rc == "succ") {
										this.process++
									}
								})
							}
						})
						break;
					case 4:
						cnt = {
							id: this.ID,
							authorInfo: this.authorInfoForm
						}

						if (this.authorInfoForm[0].authorName != '' && this.authorInfoForm[0].authorName != null &&
							this.authorInfoForm[0].authorEmail != '' && this.authorInfoForm[0].authorEmail != null &&
							this.authorInfoForm[0].authorPhone != '' && this.authorInfoForm[0].authorPhone != null &&
							this.authorInfoForm[0].authorCompany[0].name != '' && this.authorInfoForm[0].authorCompany[0].name != null) {
							this.$api.updatePaper(cnt, res => {
								if (res.status == 200 && res.data.rc == "succ") {
									this.process++;
									this.step++;
								}
							})
						} else {
							alert("请填写完整信息")
						}
						// this.$refs[formName].validate((valid) => {
						//   if (valid) {
						//     this.$api.updatePaper(cnt, res => {
						//       if (res.status == 200 && res.data.rc == "succ") {
						//         this.process++;
						//         this.step++;
						//       }
						//     })
						//   }
						// })
						break;
					case 5:
						cnt = {
							id: this.ID,
							presentingType: this.manuscriptForm.presentingType,
							isSelection: this.manuscriptForm.isSelection,
							topic: this.manuscriptForm.topic,
							title: this.manuscriptForm.title,
							objective: this.manuscriptForm.objective,
							methods: this.manuscriptForm.methods,
							results: this.manuscriptForm.results,
							conclusion: this.manuscriptForm.conclusion,
							keywords: this.manuscriptForm.keywords,
							uploadAttachment: this.manuscriptForm.uploadAttachment
						}

						this.$refs[formName].validate((valid) => {
							if (valid) {
								if (this.manuscriptForm.uploadAttachment.length || this.manuscriptForm.isSelection == 2) {
									this.$api.updatePaper(cnt, res => {

										if (res.status == 200 && res.data.rc == "succ") {
											cnt = {
												id: this.ID
											}
											this.$api.getPaperList(cnt, res => {
												this.articleInfo = JSON.parse(res.data.c)
											})
											this.process++;
											this.step++;
										}
									})
								} else {
									alert("请上传投稿正文")
								}
							}
						})
						break;
					case 6:
						cnt = {
							id: this.ID,
							status: 2
						}
						this.$api.updatePaper(cnt, res => {
							if (res.status == 200 && res.data.rc == "succ") {
								this.process++;
								this.step += 2;
								this.authorForm = {}
								this.speakForm = {}
								this.authorInfoForm = {}
								this.manuscriptForm = {}
							}
						})
						break;
				}

			},
			//上一步
			lastStep() {
				if (this.process < 4) {
					if (this.process > 1 && this.process <= 2) {
						this.process--
					} else {
						this.step--
					}
				}
			}
		},
		components: {
			titlecom,
			pcBack,
			logocom,
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				// this.$router.push({
				// 	path: '/stay-phone'
				// })
			}
			axios.get('https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/wallpaper/wallpaper.json').then(res => {
				if (res.data.cate[0].cateName == "") {
					console.log("目前无文章")
					alert("目前无文章")
				}else {
					this.JsonData = res.data.cate;
				}
				
			}, res => {
				console.log("error")
			})

		},
	}
</script>

<style lang="scss">
	@import '@/assets/style/style.scss';

	.retrun_pc {
		float: right;
		margin: 20px 0;
		cursor: pointer;
		color: rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}

	.retrun_pc:hover {
		color: #49a8eb;
	}

	.wallpaper {
		width: 61.25rem;
		margin: 0 auto;
	}

	.cate ul li {
		width: 16%;
		padding: 2%;
		list-style: none;
		text-align: center;
		float: left;

	}

	.cate li span {
		display: block;
		line-height: 1.875rem;
	}

	.PC_headImg {
		margin: 0 auto;
		display: block;
	}

	.PC_headImg img {
		width: 100%;
	}

	.crad {
		width: 50%;
	}

	.text {
		font-size: 14px;
	}

	.item span {
		display: block;
		line-height: 3.125rem;
		white-space: nowrap;
		word-break: keep-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.item label {
		line-height: 2.5rem;
	}


	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.box-card {
		width: 480px;
	}

	.zw_require {
		//border: 1px solid #1b54a2;
		margin-top: 20px;
		padding: 20px;
		line-height: 30px;
	}

	.subMission {
		margin-bottom: 20px;
	}

	.radio-group {
		margin-bottom: 15px;
		zoom: 150%;
	}

	.but-left {
		margin-left: 20px;
	}

	.addAuthor {
		margin: 20px 0px;
	}

	.againText {
		color: red;
		cursor: pointer;
	}

	.careful_info {
		margin-left: 0px;
		color: red;
		font-size: 5px;
	}

	.title_info {
		text-align: center;
		word-wrap: break-word;
		word-break: break-all;

	}

	.stepBut {
		margin-top: 20px;
	}

	.tcuss {
		text-align: center;
	}

	.el-drawer.rtl {
		overflow: scroll;
	}

	.el-drawer__body {
		overflow: scroll;
	}

	.el-drawer__container ::-webkit-scrollbar {
		display: none;
	}

	.btn-box {
		display: none;
	}
	.flex {
		display: none;
	}

	@media (max-width:31.25rem) {
		.retrun_pc {
			display: none;
		}

		.wallpaper {
			width: 100%;
		}

		.cate {
			width: 100%;
		}

		.cate ul {
			padding: 0rem;
		}

		.cate ul li {
			width: 40%;
			padding: 5%;
			list-style: none;
			text-align: center;
			float: left;
		}

		.cate li span {
			display: block;
			line-height: 1.875rem;
		}

		.crad {
			width: 100%;
		}

		.retrun_phone {
			margin: 0 auto;
			line-height: 40px;
			text-align: center;
			background-color: #5e89ff;
			color: #fff;
			border-radius: 5px;
			width: 40%;

		}

		.btn-box {
			display: flex;
			position: fixed;
			width: 100%;
			background-color: #fff;
			bottom: 0;
		}

		.flex {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 135px;
			margin: 20px auto;
			margin-bottom: 10px;
		}

		.logo {
			width: 40px;
			padding: 0 5px;
			/* background-color: #f4f4f4; */
			border-radius: 3px;
		}
	}
</style>
